export default __webpack_public_path__ + "static/media/imambara.53409db0.webp";